// 3D Tilt Effect - Auto-animation & Hover
(function() {
  'use strict';
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  function init() {
    // Ecrans tactiles (telephone, tablette) : pas d'effet tilt.
    // L'effet est pilote par la souris, et le reemballage des medias casse
    // l'affichage de la cover sur le carrousel mobile de Dawn.
    if (window.matchMedia('(hover: none), (pointer: coarse)').matches) return;

    const containers = document.querySelectorAll('.product__media-item, .product__media, [data-media-id]');
    
    if (containers.length === 0) return;
    
    containers.forEach(container => {
      if (container.dataset.tiltInitialized) return;
      container.dataset.tiltInitialized = 'true';
      
      const wrapper = document.createElement('div');
      wrapper.className = 'tilt-wrapper';
      wrapper.style.cssText = `
        perspective: 1000px;
        width: 100%;
        height: 100%;
        position: relative;
      `;
      
      const parent = container.parentNode;
      parent.insertBefore(wrapper, container);
      wrapper.appendChild(container);
      
      container.style.cssText += `
        transform-style: preserve-3d;
        position: relative;
        image-rendering: -webkit-optimize-contrast;
        image-rendering: crisp-edges;
      `;

      // Pas de will-change ni de filter sur le container — évite le flou GPU
      
      let currentRotX = 0;
      let currentRotY = 0;
      let targetRotX = 0;
      let targetRotY = 0;
      let isHovering = false;
      let autoTime = Math.random() * 1000;

      let playerOn = false;

      function animate() {
        // Lecteur video charge dans ce media (prodnamovideo.js pose .pnv) : plus de
        // tilt. On retombe a plat en douceur, puis la boucle s'arrete definitivement.
        if (!playerOn) playerOn = container.classList.contains('pnv') || !!container.querySelector('.pnv');
        if (playerOn) {
          currentRotX += (0 - currentRotX) * 0.15;
          currentRotY += (0 - currentRotY) * 0.15;
          if (Math.abs(currentRotX) < 0.02 && Math.abs(currentRotY) < 0.02) {
            container.style.transform = 'none';
            wrapper.style.filter = 'none';
            return;
          }
          container.style.transform = `rotateX(${currentRotX}deg) rotateY(${currentRotY}deg)`;
          requestAnimationFrame(animate);
          return;
        }

        // Plein ecran (lecteur video) : aucun tilt. Sinon la souris est mesuree par
        // rapport au cadre d'origine -> angles enormes -> "salto" a la sortie.
        if (document.fullscreenElement || document.webkitFullscreenElement) {
          currentRotX = currentRotY = targetRotX = targetRotY = 0;
          container.style.transform = 'none';
          wrapper.style.filter = 'none';
          requestAnimationFrame(animate);
          return;
        }

        if (isHovering) {
          currentRotX += (targetRotX - currentRotX) * 0.1;
          currentRotY += (targetRotY - currentRotY) * 0.1;
        } else {
          autoTime += 0.015;
          targetRotX = Math.sin(autoTime) * 2;
          targetRotY = Math.cos(autoTime * 0.8) * 2;
          
          currentRotX += (targetRotX - currentRotX) * 0.05;
          currentRotY += (targetRotY - currentRotY) * 0.05;
        }
        
        // Ombre sur le wrapper (pas sur le container) → pas de flou sur l'image
        const shadowX = currentRotY * -3;
        const shadowY = currentRotX * 3;
        const shadowBlur = Math.abs(currentRotX) + Math.abs(currentRotY) * 2;
        const shadowOpacity = Math.min(0.12, (Math.abs(currentRotX) + Math.abs(currentRotY)) / 25);
        
        container.style.transform = `rotateX(${currentRotX}deg) rotateY(${currentRotY}deg)`;
        wrapper.style.filter = `drop-shadow(${shadowX}px ${shadowY}px ${shadowBlur}px rgba(0, 0, 0, ${shadowOpacity}))`;
        
        requestAnimationFrame(animate);
      }
      
      requestAnimationFrame(animate);
      
      wrapper.addEventListener('mouseenter', () => {
        isHovering = true;
      });
      
      wrapper.addEventListener('mousemove', (e) => {
        const rect = wrapper.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        const centerX = rect.width / 2;
        const centerY = rect.height / 2;
        
        // borne a [-1, 1] : jamais plus de 5deg, meme si la souris est hors du cadre
        const nx = Math.max(-1, Math.min(1, (x - centerX) / centerX));
        const ny = Math.max(-1, Math.min(1, (y - centerY) / centerY));
        targetRotY = nx * 5;
        targetRotX = ny * -5;
      });

      // entree / sortie du plein ecran : on repart a plat, sans a-coup
      ['fullscreenchange', 'webkitfullscreenchange'].forEach(ev => {
        document.addEventListener(ev, () => {
          isHovering = false;
          currentRotX = currentRotY = targetRotX = targetRotY = 0;
        });
      });
      
      wrapper.addEventListener('mouseleave', () => {
        isHovering = false;
      });
    });
    
    document.addEventListener('shopify:section:load', () => {
      setTimeout(init, 100);
    });
  }
})();